//
// Currency
//

export function formatMoney(amount: number, currency: string) {
	return new Intl.NumberFormat(undefined, {
		style: "currency",
		currency: currency.toUpperCase(),
	}).format(amount);
}

// Short money for axis ticks/labels: "$1.2K" with a narrow symbol ("$" not
// "US$") so it stays compact and doesn't clip.
export function formatMoneyCompact(amount: number, currency: string) {
	return new Intl.NumberFormat(undefined, {
		style: "currency",
		currency: currency.toUpperCase(),
		currencyDisplay: "narrowSymbol",
		notation: "compact",
		maximumFractionDigits: 1,
	}).format(amount);
}

//
// Number
//

export const compactNumberFmt = new Intl.NumberFormat("en", {
	notation: "compact",
});

//
// Time
//

export const simpleDateFmt = new Intl.DateTimeFormat(undefined, {
	month: "short",
	day: "numeric",
});

const dateFmt = new Intl.DateTimeFormat(undefined, {
	year: "numeric",
	month: "short",
	day: "numeric",
});

export function formatDate(iso: string | null): string {
	if (!iso) return "-";
	return dateFmt.format(new Date(iso));
}

const dateTimeFmt = new Intl.DateTimeFormat(undefined, {
	year: "numeric",
	month: "short",
	day: "numeric",
	hour: "2-digit",
	minute: "2-digit",
	second: "2-digit",
});

export function formatDateTime(iso: string | null): string {
	if (!iso) return "-";
	return dateTimeFmt.format(new Date(iso));
}
